import { Chip, chipClasses, Icon } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBreadcrumb = styled(Chip, { shouldForwardProp: prop => prop !== 'last' && prop !== 'draggedOver' })(({ theme, last, draggedOver }) => {
    const backgroundColor = last ? theme.palette.navigation.background.selected : draggedOver ? theme.palette.common.lightblue : theme.palette.common.lightgray;
    const color = last ? theme.palette.navigation.span.main : theme.palette.common.black;

    return {
        color,
        backgroundColor,
        border: 'none',
        borderRadius: '12px',
        height: theme.spacing(6),
        padding: theme.spacing(1, 2),
        cursor: last ? 'default' : 'pointer',
        fontSize: theme.typography.pxToRem(12),
        '&:hover, &:focus, &:active': {
            backgroundColor: last ? backgroundColor : theme.palette.common.lightblue,
            color: last ? color : theme.palette.link.main
        },
        [`& .${chipClasses.label}`]: { padding: 0 }
    };
});

const UploadIcon = styled(Icon)(({ theme }) => ({
    backgroundColor: theme.palette.hover.main,
    color: theme.palette.link.main,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    borderRadius: '50%',
    height: 64,
    width: 64,
    fontSize: 40,
    padding: 12,
    marginBottom: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': { backgroundColor: theme.palette.common.accentgray, color: 'white' }
}));

export { StyledBreadcrumb, UploadIcon };
